import { qidaApi } from 'yxt-biz-pc/packages/api';

export const getMobileCaptch = data => {
  return qidaApi.post('/auth/anonymous/sms', data);
};

export const postAnonyLogin = data => {
  return qidaApi.post('/auth/anonymous/phone', data);
};
